<template>
  <div class="vanilla-f-wrap">
    <main class="screen" role="main" aria-labelledby="section-heading">

      <div class="checkmark-wrap">
        <div class="checkmark-circle">
          <svg class="checkmark-svg" viewBox="0 0 40 40" aria-hidden="true">
            <polyline points="10,21 17,28 30,13"/>
          </svg>
        </div>
      </div>

      <p class="eyebrow">Abschnitt abgeschlossen</p>
      <h1 id="section-heading" class="title">Schön gemacht!</h1>
      <p class="subtitle">Du hast alle Fragen zum Thema {{ completedSection }} beantwortet.</p>

      <div
        class="progress-row"
        role="progressbar"
        :aria-valuenow="doneCount"
        aria-valuemin="0"
        :aria-valuemax="sections.length"
      >
        <div
          v-for="s in sections"
          :key="s.title"
          class="progress-dot"
          :class="s.status"
          :title="s.title"
        ></div>
      </div>

      <p class="progress-text">
        <strong>{{ doneCount }} von {{ sections.length }} Abschnitten</strong> geschafft
      </p>

      <div class="fact-card">
        <p class="fact-label">Wusstest du?</p>
        <p class="fact-text">{{ fact }}</p>
      </div>

      <div class="up-next">
        <div>
          <p class="up-next-label">Als Nächstes</p>
          <p class="up-next-section">{{ upNext.section }}</p>
        </div>
        <span class="up-next-count">{{ upNext.questions }} Fragen</span>
      </div>

      <div class="footer">
        <button type="button" class="continue-button" @click="goNext">Weiter</button>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: 'VanillaF',
  data() {
    return {
      completedSection: 'Früchte',
      sections: [
        { title: 'Gemüse', status: 'done' },
        { title: 'Früchte', status: 'done' },
        { title: 'Tierische Proteine', status: 'current' },
        { title: 'Pflanzliche Proteine', status: '' },
        { title: 'Getreide', status: '' },
        { title: 'Milchprodukte', status: '' },
        { title: 'Getränke', status: '' },
      ],
      fact: 'Eine Portion Frucht entspricht etwa 120g. Das ist eine mittelgrosse Frucht, eine Handvoll Beeren oder ein Becher geschnittene Früchte.',
      upNext: { section: 'Tierische Proteine', questions: 8 },
    };
  },
  computed: {
    doneCount() {
      return this.sections.filter(s => s.status === 'done').length;
    },
  },
  methods: {
    goNext() {
      this.$router.push('/postsurvey/email');
    },
  },
};
</script>

<style scoped>
.vanilla-f-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-progress-fill: #534AB7;
  --color-good: #2D8659;
  --color-good-soft: rgba(45, 134, 89, 0.12);
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.vanilla-f-wrap *,
.vanilla-f-wrap *::before,
.vanilla-f-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 2rem 1.5rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.checkmark-wrap {
  display: flex;
  justify-content: center;
  margin: 1rem 0 1.5rem;
}

.checkmark-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--color-good-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pop 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28) both;
  position: relative;
}

.checkmark-circle::before {
  content: "";
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  background: var(--color-good-soft);
  opacity: 0;
  animation: ripple 1.2s ease-out 0.2s both;
}

.checkmark-svg {
  width: 38px;
  height: 38px;
  stroke: var(--color-good);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  animation: draw 0.4s ease-out 0.3s forwards;
}

@keyframes pop {
  0% { transform: scale(0); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes ripple {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(1.5); opacity: 0; }
}

@keyframes draw {
  to { stroke-dashoffset: 0; }
}

.eyebrow {
  font-size: 12px;
  color: var(--color-good);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin: 0 0 8px;
  animation: fade-up 0.4s ease-out 0.5s both;
}

.title {
  font-size: 26px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.25;
  color: var(--color-text-primary);
  animation: fade-up 0.4s ease-out 0.6s both;
}

.subtitle {
  font-size: 15px;
  color: var(--color-text-secondary);
  margin: 0 0 1.75rem;
  animation: fade-up 0.4s ease-out 0.7s both;
}

@keyframes fade-up {
  0% { opacity: 0; transform: translateY(8px); }
  100% { opacity: 1; transform: translateY(0); }
}

.progress-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 0 0 1.25rem;
  animation: fade-up 0.4s ease-out 0.8s both;
}

.progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color-bg-muted);
  border: 0.5px solid var(--color-border);
  transition: all 0.3s;
}

.progress-dot.done {
  background: var(--color-good);
  border-color: var(--color-good);
}

.progress-dot.current {
  background: var(--color-progress-fill);
  border-color: var(--color-progress-fill);
  width: 12px;
  height: 12px;
  box-shadow: 0 0 0 3px rgba(83, 74, 183, 0.15);
}

.progress-text {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 1.75rem;
  animation: fade-up 0.4s ease-out 0.9s both;
}

.progress-text strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

.fact-card {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin: 0 0 1.5rem;
  text-align: left;
  animation: fade-up 0.4s ease-out 1.0s both;
}

.fact-label {
  font-size: 10px;
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
  margin: 0 0 6px;
}

.fact-text {
  font-size: 14px;
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1.55;
}

.up-next {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: var(--color-bg-card);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-bottom: 1.5rem;
  animation: fade-up 0.4s ease-out 1.1s both;
  text-align: left;
}

.up-next-label {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
  margin: 0 0 2px;
}

.up-next-section {
  font-size: 14px;
  color: var(--color-text-primary);
  font-weight: 500;
  margin: 0;
}

.up-next-count {
  font-size: 12px;
  color: var(--color-text-tertiary);
}

.footer {
  margin-top: auto;
  animation: fade-up 0.4s ease-out 1.2s both;
}

.continue-button {
  width: 100%;
  padding: 14px;
  background: var(--color-progress-fill);
  color: white;
  border: 0.5px solid var(--color-progress-fill);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s;
}

.continue-button:hover {
  opacity: 0.9;
}
</style>
